import {
  State,
  OwnsBookPayload as Payload,
} from "components/bookShuffle/useBookShuffle/types";

/**
 * Sets if the user owns the currently active book
 */
export function ownsBook(state: State, payload: Payload): State {
  const { currentIndex } = state;
  const { ownsBook } = payload;

  const books = [...state.books];
  books[currentIndex] = {
    ...books[currentIndex],
    ownsBook,
  };

  return {
    ...state,
    books,
  };
}
